const PLANS = {
  free: ['brief'],
  economy: ['brief', 'counterparty', 'sources', 'settings'],
  autopilot: ['brief', 'counterparty', 'contracts', 'notifications', 'sources', 'settings'],
};

export function canAccess(feature) {
  const plan = localStorage.getItem('khepri_plan') || 'autopilot';
  return (PLANS[plan] || []).includes(feature);
}